import { render, staticRenderFns } from "./Page5.vue?vue&type=template&id=0db0592e&scoped=true"
import script from "./Page5.vue?vue&type=script&lang=js"
export * from "./Page5.vue?vue&type=script&lang=js"
import style0 from "./Page5.vue?vue&type=style&index=0&id=0db0592e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db0592e",
  null
  
)

export default component.exports